import { IS_VIVUS, IS_VIVUS_ONLINE } from 'utils/constants';
import { routes } from '../routes';
import { useLocation } from 'react-router-dom';

// Hooks + constants + config -> useCrossDomainLoginRedirect + AppConfig + Constants

export const useProduct = () => {
  const { pathname } = useLocation();
  let valueRelatedToProduct;

  switch (pathname) {
    // useCrossDomainLoginRedirect - redirection
    case routes.FirstLoan:
    case routes.FirstLoan_Mobile:
      // Show/Hide warning
      valueRelatedToProduct = IS_VIVUS_ONLINE;
      break;
    case routes.Affiliate_FirstLoan_Application:
      // FAQ items
      valueRelatedToProduct = IS_VIVUS ? 'items_vivus' : 'items_vivusonline';
  }

  return { valueRelatedToProduct };
};
